import {Types}                      from "@Common/types";
import {oMapToArrWithIndex, values} from "@Common/utils/objects";

import {makeEmptyResultRows} from "./common/utils";

type ReportModuleFactory = Types.Xpresso.Account.Admin.Reporting.ActivityDashboard.ReportModuleFactory;
type ReportModuleTabRow  = Types.Xpresso.Account.Admin.Reporting.ActivityDashboard.ReportModuleTabResultRow;

const TITLES:{[key in Types.Apis.Payloads.Next.Reporting.TransactionInformation.ResponseType]: string} = {
    ordersMonthToDate     : "Orders Month to Date",
    ordersLastMonth       : "Orders Same Period Last Month",
    ordersGrowthLastMonth : "Orders Growth",
    volumeMonthToDate     : "Number of pieces Month to Date",
    volumeLastMonth       : "Number of pieces Same Period Last Month",
    volumeGrowthLastMonth : "Number of pieces Growth",
    ordersYearToDate      : "Orders Year to Date",
    ordersLastYear        : "Orders Same Period Last Year",
    ordersGrowthLastYear  : "Orders Growth",
    volumeYearToDate      : "Number of pieces Year to Date",
    volumeLastYear        : "Number of pieces Same Period Last Year",
    volumeGrowthLastYear  : "Number of pieces Growth",
};

export const makeTransactionInformationModule:ReportModuleFactory = ({apis}) => ({
    name                : "transactionInformation",
    title               : "Transaction Information",
    tabs                : ["This Month", "YTD"],
    load                : async ({idBranch, idRegion}) => {
        try {
            const apiResult = await apis.next.reporting.transactionInformation({idBranch, idRegion});
            return [
                oMapToArrWithIndex(apiResult.transactionInformationMonth, mapResultEntryAsTabRow),
                oMapToArrWithIndex(apiResult.transactionInformationYear, mapResultEntryAsTabRow),
            ];
        } catch (error) {
            console.error(error);
            return [makeEmptyResultRows({titles: values(TITLES)})];
        }
    },
    supportsBranchLevel : true,
});

const mapResultEntryAsTabRow = (
    value: number | string,
    key: Types.Apis.Payloads.Next.Reporting.TransactionInformation.ResponseType,
) : ReportModuleTabRow => {
    let content:React.ReactNode;
    let title:string;
    switch (key) {
        case "ordersGrowthLastMonth":
        case "volumeGrowthLastMonth":
        case "ordersGrowthLastYear":
        case "volumeGrowthLastYear":
            content = typeof value === "number" ? (value * 100).toFixed(2) + "%" : value;
            break;

        case "ordersMonthToDate":
        case "ordersLastMonth":
        case "volumeMonthToDate":
        case "volumeLastMonth":
        case "ordersYearToDate":
        case "ordersLastYear":
        case "volumeYearToDate":
        case "volumeLastYear":
            content = value ?? 0;
            break;
    }

    return {content, title: TITLES[key]};
};

